/* eslint-disable react/prop-types */
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { FormikDateField, FormikSingleSelect, FormikTextField } from '../../../../../components/FormikFields'
import { PW_MANAGER_SELECT_PROPS } from '../../../../../util/inputAttrs'
import { FORM_FIELDS } from '../constants'

function JobInformation(props) {
  const { intl, employeeEmailOptions = [], showOnlyBasicFields = false } = props

  return (
    <Row className="mb-4">
      <Col sm="12">
        <h6 className="fw-bold mb-4" style={{ fontSize: '1rem', color: 'var(--bs-body-color)' }}>
          <FormattedMessage id="FORM.JOB_INFORMATION" />
        </h6>

        <FormikTextField
          id={FORM_FIELDS.JOB_TITLE}
          title="FORM.JOB_TITLE"
          placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_JOB_TITLE' })}
          inline
          disablePasswordManager
        />
        {!showOnlyBasicFields && (
          <FormikTextField
            id={FORM_FIELDS.COMPANY_NAME}
            title="FORM.COMPANY_NAME"
            placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_COMPANY_NAME' })}
            inline
            disablePasswordManager
          />
        )}
        <FormikTextField
          id={FORM_FIELDS.DEPARTMENT}
          title="FORM.DEPARTMENT"
          placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_DEPARTMENT' })}
          inline
          disablePasswordManager
        />
        {!showOnlyBasicFields && (
          <>
            <FormikTextField
              id={FORM_FIELDS.EMPLOYEE_ID}
              title="FORM.EMPLOYEE_ID"
              placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_EMPLOYEE_ID' })}
              inline
              disablePasswordManager
            />
            <FormikTextField
              id={FORM_FIELDS.EMPLOYEE_TYPE}
              title="FORM.EMPLOYEE_TYPE"
              placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_EMPLOYEE_TYPE' })}
              inline
              disablePasswordManager
            />
            <FormikDateField
              id={FORM_FIELDS.HIRE_DATE}
              title="FORM.EMPLOYEE_HIRE_DATE"
              placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_HIRE_DATE' })}
              inline
            />
            <FormikTextField
              id={FORM_FIELDS.OFFICE_LOCATION}
              title="FORM.OFFICE_LOCATION"
              placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_OFFICE_LOCATION' })}
              inline
              disablePasswordManager
            />
            <FormikSingleSelect
              id={FORM_FIELDS.MANAGER}
              title="FORM.MANAGER"
              defaultLabel={intl.formatMessage({ id: 'PLACEHOLDER.SELECT_EMPLOYEE' })}
              options={employeeEmailOptions}
              inline
              {...PW_MANAGER_SELECT_PROPS}
            />
          </>
        )}
      </Col>
    </Row>
  )
}

export default JobInformation
